module.exports = __webpack_public_path__ + "static/media/logo.e7271b8b.png";